module.exports = __webpack_public_path__ + "static/img/top_img.1051dd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/top_img.jpg
// module id = 2QJI
// module chunks = 0